import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../Api/Api";
import { username } from "../../API";

const LatestHome = () => {
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const { data } = await Api.getLatest();
        setLatest(data || []);
      } catch (error) {
        console.error("Error fetching latest data:", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [username]);

  const generateSlug = (title, id) =>
    `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;

  const slugify = (text = "") =>
    text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

  return (
    <div className="container-fluid py-3" style={{ background: "aliceblue" }}>
      {loading ? (
       <div className="d-flex justify-content-center align-items-center py-5">
          <div
            className="spinner-grow text-primary"
            style={{ width: "3rem", height: "3rem" }}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
       
      ) : latest.length ? (
        <>
          <h5 className="fw-bold mb-3 text-dark fs-4">Latest</h5>

          <div className="row g-4">
            {latest.map((movie) => (
              <div
                key={movie._id}
                className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
              >
                <Link
                  to={
                    movie?.channelType === "Subchannels"
                      ? `/${slugify(
                        movie?.channel?.parentChannel?.name
                      )}/channel/${slugify(
                        movie?.channel?.name
                      )}/${generateSlug(movie?.title, movie._id)}`
                      : `/${slugify(
                        movie?.channel?.name
                      )}/${generateSlug(movie?.title, movie._id)}`
                  }
                  className="text-decoration-none text-dark"
                >
                  <div
                    className="card h-100 shadow-sm border-0"
                    style={{
                      borderRadius: "12px",
                    }}
                  >
                    <img
                      src={movie.thumbnail}
                      alt={movie.title}
                      className="card-img-top"
                      style={{
                        height: "180px",
                        objectFit: "fill",
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                      }}
                    />

                    <div className="card-body d-flex align-items-center justify-content-center p-2">
                      <span
                        className="fw-semibold text-center text-truncate w-100"
                        title={movie.title}
                        style={{ fontSize: "1rem" }}
                      >
                        {movie.title}
                      </span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="text-muted">No latest data available</p>
      )}
    </div>
  );
};

export default LatestHome;
